export const getPartnerCoords = (partner) => {
  if (!partner) return { lat: null, lng: null };
  const lat =
    partner.latitude ?? partner.lat ?? partner.locationLatitude ?? partner.locationLat ?? null;
  const lng =
    partner.longitude ?? partner.lng ?? partner.locationLongitude ?? partner.locationLng ?? null;

  const parsedLat = typeof lat === "string" ? Number(lat) : lat;
  const parsedLng = typeof lng === "string" ? Number(lng) : lng;

  return { lat: parsedLat, lng: parsedLng };
};

const degToRad = (value) => (value * Math.PI) / 180;

export const computeDistanceKm = (origin, partner) => {
  if (!origin || origin.lat == null || origin.lng == null || !partner) return null;

  const { lat, lng } = getPartnerCoords(partner);
  if (lat == null || lng == null) return null;

  const R = 6371; // km
  const dLat = degToRad(lat - origin.lat);
  const dLng = degToRad(lng - origin.lng);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(degToRad(origin.lat)) *
      Math.cos(degToRad(lat)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;

  if (!Number.isFinite(distance)) return null;
  return distance;
};
